<template>
  <v-form
    class="admin-new-order-manage-line-item my-3 proxima--font"
    @submit.prevent="() => {}"
  >
    <v-row dense>
      <v-col cols="12">
        <v-btn
          color="blue darken-2 white--text"
          depressed
          small
          class="mr-2"
          v-tooltip="
            hasUnfinishedProduct
              ? getTooltipHtml('Finish adding current Item first.')
              : false
          "
          @click="addProduct"
          >+ Item</v-btn
        >
        <!-- <v-btn
          color="blue darken-2 white--text"
          depressed
          small
          class="mr-2"
          v-tooltip="
            hasUnfinishedDiscount
              ? getTooltipHtml('Finish adding current Discount first.')
              : false
          "
          @click="addDiscount"
          >+ Discount</v-btn
        > -->
      </v-col>
    </v-row>
    <v-row dense v-if="cart.products.length">
      <v-col cols="12">
        <h3>Items</h3>
        <v-divider class="my-2" />
        <v-row>
          <v-col cols="12">
            <v-row dense class="font-weight-bold" justify="space-between">
              <v-col cols="4" class="text-left">Item</v-col>
              <v-col cols="2" class="text-center">Price</v-col>
              <v-col cols="2" class="text-center">Quantity</v-col>
              <v-col cols="2" class="text-center">Total</v-col>
              <v-col cols="1" class="text-center mr-4 btn-spacer"></v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col
            cols="12"
            v-for="(item, i) of cart.products"
            :key="`${i}-line-item`"
          >
            <AdminNewOrderBuilderLineItem
              :item="item"
              @update="updateItem(item.id, $event)"
              @remove="removeItem(item.id)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense v-if="cart.discounts.length">
      <v-col cols="12">
        <h3>Discounts</h3>
        <v-divider class="my-2" />
        <v-row>
          <v-col cols="12">
            <v-row dense class="font-weight-bold" justify="space-between">
              <v-col cols="4" class="text-left">Name</v-col>
              <v-col cols="2" class="text-center">Discount</v-col>
              <v-col cols="2" class="text-center">Quantity</v-col>
              <v-col cols="2" class="text-center">Total</v-col>
              <v-col cols="1" class="text-center mr-4 btn-spacer"></v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            cols="12"
            v-for="(item, i) of cart.discounts"
            :key="`${i}-discount`"
          >
            <AdminNewOrderBuilderDiscount
              :item="item"
              @update="updateItem(item.id, $event)"
              @remove="removeItem(item.id)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="my-2" />

    <transition name="slide-x-transition" mode="out-in">
      <div
        v-if="
          Number(cart.total) !== 0 || cart.subtotal !== 0 || items.length > 0
        "
      >
        <div class="text-h6 text-right"
          >Subtotal: {{ formatUSD(cart.subtotal) }}</div
        >
        <div class="text-h6 text-right" v-if="cart.discounts_total !== 0"
          >Discounts: {{ formatUSD(-cart.discounts_total) }}</div
        >
        <transition name="slide-x-transition">
          <div class="text-right text-h6" v-if="cart.sales_tax" key="tax"
            >Sales Tax ({{ cart.sales_tax }}%):
            {{ cart.sales_tax_formatted }}</div
          >
        </transition>
        <transition name="slide-x-transition">
          <div class="text-right text-h6" key="service-fee"
            >Service Fee ({{ cart.service_fee_percentage }}%)
            <v-btn
              x-small
              icon
              class="mb-1"
              v-if="getShopHasActiveTrial"
              v-tooltip="getServiceFeeTooltip"
            >
              <v-icon x-small>mdi-information</v-icon>
            </v-btn>
            :
            <span
              class="service-fee-amount"
              :class="{ 'service-fee-active-trial': getShopHasActiveTrial }"
              >{{ cart.service_fee_formatted }}</span
            ></div
          >
        </transition>
        <AdminNewOrderBuilderMetaItem
          label="Delivery Fee"
          :value="cart.delivery_fee_applied"
          @update="updateCart({ custom_delivery_fee: $event })"
          @add="updateCart({ custom_delivery_fee: getDeliveryFee })"
          @remove="updateCart({ custom_delivery_fee: null })"
        />
        <AdminNewOrderBuilderMetaItem
          label="Tip"
          :value="cart.tip"
          @update="updateCart({ tip: $event })"
          @add="updateCart({ tip: getTipDefault })"
          @remove="updateCart({ tip: null })"
        />
        <transition name="slide-x-transition">
          <div
            class="text-right text-h6"
            v-if="cart.family_discount_pcnt"
            key="fam-dis"
            >Family Discount ({{ cart.family_discount_pcnt * 100 }}%):
            {{ formatUSD(-cart.family_discount_amount) }}</div
          >
        </transition>
        <div class="font-weight-bold text-right text-h5 mt-2"
          >Total: {{ formatUSD(cart.total) }}</div
        >
      </div>
      <v-alert v-else outlined type="info">
        Create Order Items by using the buttons above.
      </v-alert>
    </transition>
  </v-form>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import formatUSD from '@/utils/formatUSD'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'

import CartModel from '@/models/CartModel'
import CustomerModel from '@/models/CustomerModel'
import CartItemModel from '@/models/CartItemModel'
import LineItemModel from '@/models/LineItemModel'
import AdminNewOrderBuilderLineItem from '@/components/AdminNewOrderBuilderLineItem'
import AdminNewOrderBuilderDiscount from '@/components/AdminNewOrderBuilderDiscount'
import AdminNewOrderBuilderMetaItem from '@/components/AdminNewOrderBuilderMetaItem'
export default {
  name: 'AdminNewOrderBuilder',
  components: {
    AdminNewOrderBuilderLineItem,
    AdminNewOrderBuilderDiscount,
    AdminNewOrderBuilderMetaItem,
  },
  props: {
    cart: {
      type: CartModel,
      require: true,
      default: () => new CartModel(),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('shop', [
      'getSalesTaxPcnt',
      'getTipDefault',
      'getDeliveryFee',
      'getShopHasActiveTrial',
    ]),
    customerId() {
      return this.cart.user_id
    },
    customer() {
      if (!this.customerId) return false
      return CustomerModel.find(this.customerId)
    },
    items() {
      return this.cart.cartItems
    }, // items
    hasUnfinishedProduct() {
      let lastProduct = this.cart.products.at(-1)
      return lastProduct && !_get(lastProduct, 'item_id')
    },
    hasUnfinishedDiscount() {
      let lastDiscount = this.cart.discounts.at(-1)
      return lastDiscount && !_get(lastDiscount, 'item_name')
    },
    isTouchEnabled() {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      )
    }, // isTouchEnabled
    tooltipTrigger() {
      return this.isTouchEnabled ? 'click' : 'hover'
    }, // tooltipTrigger
    getServiceFeeTooltip() {
      return {
        content: `<div class="service-fee-tooltip caslon--font">
                  <h2 class="popup-title">Minimart Service Fee</h2>
                  <div class="popup-content">Service Fees are waived during the free trial!</div>
                </div>`,
        html: true,
        placement: 'left',
        triggers: [this.tooltipTrigger],
      }
    }, // getServiceFeeTooltip
  },
  methods: {
    addItem(type) {
      CartItemModel.insertOrUpdate({
        where: uuidv4(),
        data: { type, quantity: 1, cart_id: this.cart.id, is_custom: true },
      })
    },
    removeItem(itemId) {
      CartItemModel.delete(itemId)
    },
    updateItem(cartItemId, updates) {
      CartItemModel.insertOrUpdate({ data: { id: cartItemId, ...updates } })
    },
    addProduct() {
      if (this.hasUnfinishedProduct) return
      this.addItem(LineItemModel.lineItemTypes.PRODUCT)
    },
    addDiscount() {
      if (this.hasUnfinishedDiscount) return
      this.addItem(LineItemModel.lineItemTypes.DISCOUNT)
    },
    updateCart(keyVal) {
      CartModel.insertOrUpdate({
        data: { id: this.cart.id, ...keyVal },
      })
    },
    getTooltipHtml(string) {
      return {
        content: `<div class="proxima--font">${string}</div>`,
        triggers: ['hover', 'click'],
        html: true,
      }
    }, // getTooltipHtml
    formatUSD,
  },
}
</script>

<style lang="scss">
.service-fee-tooltip {
  max-width: 250px;
  padding: 7px 5px;
  .popup-title {
    margin-bottom: 5px;
  }
  .popup-content {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }
}
.service-fee-active-trial {
  text-decoration: line-through;
}
</style>
